import CircleCheckBigSvg from '@assets/images/svg/circle-check-big.svg';
import React from 'react';
import { View } from 'react-native';

export interface CircleCheckBigIconProps {
  size?: number;
  color?: string;
}

export function CircleCheckBigIcon({ size = 24, color = '#388E3C' }: CircleCheckBigIconProps) {
  return (
    <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
      <CircleCheckBigSvg width={size} height={size} color={color} />
    </View>
  );
}

export default CircleCheckBigIcon;

